import { render, staticRenderFns } from "./Expert2List.vue?vue&type=template&id=1b17d661&scoped=true&"
import script from "./Expert2List.vue?vue&type=script&lang=js&"
export * from "./Expert2List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b17d661",
  null
  
)

export default component.exports